// Global error listener that forwards errors to logger and Sentry
import logger from './logger';

// Only attach in production environments
const isProd = (import.meta as any).env?.MODE === 'production' || process.env.NODE_ENV === 'production';

const SENSITIVE_KEYWORDS = [
  'password', 'token', 'secret', 'key', 'credential',
  'auth', 'session', 'jwt', 'bearer', 'api_key'
];

function sanitizeLogMessage(message: string): string {
  let sanitized = message;
  SENSITIVE_KEYWORDS.forEach(keyword => {
    const regex = new RegExp(`${keyword}[=:][^\\s,}]+`, 'gi');
    sanitized = sanitized.replace(regex, `${keyword}=***`);
  });
  return sanitized;
}

async function logWithVisualData(errorMessage: string, originalError?: unknown) {
  try {
    const mod = await import('@/components/debug/VisualDebugger');
    const logs = mod.VisualLogger.getInstance().getLogs().map((log: any) => ({
      ...log,
      message: typeof log.message === 'string' ? sanitizeLogMessage(log.message) : log.message
    }));
    // Passing the original error lets the logger derive error_code and, when the
    // VisualLogger buffer is empty, a normalized error context as additional_info.
    await logger.logError('global', errorMessage, { additionalInfo: logs, error: originalError });
  } catch (err) {
    // In case loading VisualLogger fails, just log the original error
    await logger.logError('global', errorMessage, { error: originalError });
  }
}

if (isProd && typeof window !== 'undefined') {
  window.addEventListener('error', event => {
    const message = event.message || (event.error ? event.error.message : 'Unknown error');
    logWithVisualData(message, event.error);
  });

  window.addEventListener('unhandledrejection', event => {
    const reason = (event as PromiseRejectionEvent).reason;
    const message = reason instanceof Error ? reason.message : String(reason);
    logWithVisualData(message, reason);
  });
}

export {}; // module side-effects only
